const destroy_fullscreen_layer = () => {
  // cleaning up cached html by turbo
  document.body?.classList?.remove("no-scroll")
  // clean up html created by react portal inside this container
  const container = document.getElementById("fullscreen_layer_container")
  if (container) container.innerHTML = ""
}

export default destroy_fullscreen_layer
